import { GALLERY, GALLERY_NOTE } from "../data/content";

export function Gallery() {
  return (
    <section id="gallery" className="gallery">
      <div className="section-head">
        <p className="eyebrow">Gallery</p>
        <h2 className="h2">Us, lately</h2>
      </div>

      <div className="grid grid--gap24 auto-240 gallery__grid">
        {GALLERY.map((item) => (
          <figure
            className="placeholder placeholder--dim gallery__figure"
            key={item.label}
            data-par={String(item.speed)}
            style={{ height: item.height }}
          >
            {/* TODO: drop the real photographs into these frames. */}
            <figcaption className="mono-caption">{item.label}</figcaption>
          </figure>
        ))}
      </div>

      <p className="fine gallery__note">{GALLERY_NOTE}</p>
    </section>
  );
}
